export default {
  pageTitle: 'Selecione uma organização:',
};
